export default {
  title: 'Følg ordre',
};
